export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="relative bg-background-900">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                6080新视觉影视
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              6080新视觉影视提供电视剧全集在线观看，最新电视剧更新，热门剧集完整版，连续剧免费看，高清不缓冲，追剧首选。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-500/20 transition-colors">
                <i className="ri-wechat-line text-foreground-300 text-lg"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-500/20 transition-colors">
                <i className="ri-weibo-line text-foreground-300 text-lg"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-500/20 transition-colors">
                <i className="ri-bilibili-line text-foreground-300 text-lg"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">追剧索引</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精彩片花</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-background-50 mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">国产剧</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">韩剧专区</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">美剧日剧</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">经典重温</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-background-50 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-foreground-500">更多合作伙伴即将入驻</p>
            </div>
            <div className="mt-6">
              <h4 className="font-heading font-bold text-sm text-background-50 mb-3">关于我们</h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</a>
                <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
                <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
              </nav>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 6080新视觉影视 - 高清追剧首选平台。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>电视剧全集在线</span>
              <span>最新电视剧更新</span>
              <span>热门剧集完整版</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}